import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectPreselectedForms= createSelector(
  [
    (store: RootState) => store.profileFormAssigned.preselectedForms,
  ],
  (preselectedForms) => {
    const orderedList = [...preselectedForms].sort((a, b) => {
        if (a.name && b.name && a.name < b.name) {
          return -1;
        }
        if (a.name && b.name && a.name > b.name) {
          return 1;
        }
        return 0;
      });
  
      return orderedList;
  }
);